export const LOCAL_STORAGE_QUERY_KEY = 'outer_pages_query_string';
